/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diet_PescatarianInputs */

const en_diet_pescatarian = /** @type {(inputs: Diet_PescatarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pescatarian`)
};

const de_diet_pescatarian = /** @type {(inputs: Diet_PescatarianInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pescetarisch`)
};

/**
* | output |
* | --- |
* | "Pescatarian" |
*
* @param {Diet_PescatarianInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diet_pescatarian = /** @type {((inputs?: Diet_PescatarianInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diet_PescatarianInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_diet_pescatarian(inputs)
	return en_diet_pescatarian(inputs)
});